import React, { useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
//----------------MUI-----------------//
import { makeStyles } from "@mui/styles";
//----------------MUI ICONS-----------------//
import Settings from "@mui/icons-material/Settings";
import WebIcon from "@mui/icons-material/Web";
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
//----------------EXTERNAL COMPONENTS-----------------//
import Navbar from "components/Navbars/Navbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import SC from "components/ServiceCreator";
import SM from "components/Service Management";
import ThresholdProfiles from "components/ThresholdProfilesManagement";

const useStyles = makeStyles({
  root: { backgroundColor: "#eeeeee" },
  component: {
    backgroundColor: "#eeeeee",
    position: "absolute",
    top: "64px",
    left: "60px",
    padding: "20px 15px 20px 15px",
    minHeight: "calc(100vh - 64px)",
    minWidth: "calc(100vw - 60px)",
  },
});

export default function Manager(props) {
  const classes = useStyles();
  const metaDataValue = useSelector((state) => state.metaData);
  const isInitialized = useRef(false);
  let previousUrl = "catalogue";
  let currentService = window.localStorage.getItem("currentService");
  if(currentService != "") {
    previousUrl = currentService;
  }

  useEffect(() => {
    if (isInitialized.current) {
      // console.log("Component already initialized, skipping effect");
      return;
    }
    
    // console.log("Initializing component for the first time", metaDataValue);
    isInitialized.current = true; // Set the flag to true after first initialization

    const timer = setTimeout(() => {
      isInitialized.current = false; // Reset the flag after 10 seconds
    }, 10000); // 10 seconds delay

    // Cleanup the timer on component unmount
    return () => clearTimeout(timer);
  }, [metaDataValue]); // Dependency array to re-run effect if metaDataValue changes

  function getPermission(chk) {
    let value;
    metaDataValue.appPaths.forEach((elm) => {
      if (elm.name == chk) {
        value = elm.permission;
      }
    });
    return value;
  }

  function getRoutes() {
    let newData = [];
    newData.push({
      icon: adminRoutes["Back Button"].icon,
      layout: adminRoutes["Back Button"].layout,
      name: adminRoutes["Back Button"].name,
      path: adminRoutes["Back Button"].path,
      permission: adminRoutes["Back Button"].permission,
    })
    metaDataValue.appPaths.forEach((elm) => {
      // Defense-in-depth (appPaths is already whitelisted to the 3 SM page-tabs): skip any tab
      // with no adminRoutes entry so an unknown tab cannot blank the layout.
      if (elm.layout === "/solutionManagement/" && adminRoutes[elm.name]) {
        let temp = { ...elm };
        temp.icon = adminRoutes[temp.name].icon;
        temp.component = adminRoutes[temp.name].component;
        newData.push(temp);
      }
    });
    return newData;
  }

  const adminRoutes = {
    "Back Button": {
      icon: KeyboardReturnOutlinedIcon,
      layout: "/solutions/",
      name: "Back to Solution",
      path: previousUrl,
      permission: "ALL",
      redirectToSolution: true
    },
    "Solution Creation": {
      icon: WebIcon,
      component: (
        <SC
          permission={getPermission("Solution Creation")}
          history={props.history}
        />
      ),
    },
    "Solution Edit": {
      icon: Settings,
      // component: <ThresholdProfiles />,
      component: <SM permission={getPermission("Solution Edit")} history={props.history} />,
    },
    "Threshold Management": {
      icon: DataThresholdingIcon,
      component: <ThresholdProfiles permission={getPermission("Threshold Management")} />,
    },
  };

  function getFirstRoute(chk) {
    let output = [];
    metaDataValue.appPaths.forEach((elm) => {
      if (elm.layout === chk) {
        output.push(elm);
      }
    });
    // P2b: a role granted only Solution-Management FIELD-parts (with all 3 page-tabs disabled) has
    // NO /solutionManagement/ route in appPaths -> output is empty. Guard against output[0] to avoid
    // a TypeError from the always-rendered <Redirect>; an empty path just lands on the (routeless)
    // layout root instead of crashing.
    return output.length ? output[0].path : "";
  }

  const switchRoutes = (
    <Switch>
      {metaDataValue.appPaths.map((prop, key) => {
        if (prop.layout === "/solutionManagement/" && adminRoutes[prop.name]) {
          return (
            <Route path={prop.layout + prop.path} key={key}>
              {adminRoutes[prop.name].component}
            </Route>
          );
        }
        return null;
      })}
      {/* No Solution Management page tab -> a real landing page, not the routeless layout root. */}
      <Redirect
        to={getFirstRoute("/solutionManagement/") ? `/solutionManagement/${getFirstRoute("/solutionManagement/")}` : "/solutions/catalogue"}
      />
    </Switch>
  );

  return (
    <div className={classes.root}>
      <Sidebar routes={getRoutes()} />
      <Navbar
        routes={[
          ...metaDataValue.appPaths,
          ...[
            {
              name: "Solutions",
              path: "catalogue",
              layout: "/solutions/",
            },
          ],
        ]}
        services={metaDataValue.services}
        history={props.history}
        title = { props.location.pathname.slice(props.location.pathname.lastIndexOf("/")) == "/thresholdsManagement" ? "Thresholds Profile Management" : null }
      />
      <div className={classes.component}>{switchRoutes}</div>
    </div>
  );
}
